import React, { useState, useEffect } from "react";
import Banner from "../../components/Banner";
import axios from "../../utils/request";
import { en, ch } from "../../utils/content";
import "./index.css";
import InfinitePartnerScroll from "../../components/InfinitePartnerScroll";

const AboutPage = () => {
  const [companyInfo, setCompanyInfo] = useState<any>({});
  const [companyImg, setCompanyImg] = useState<any>([]);
  const [firends, setFirends] = useState<any>([]);
  const getFirend = async () => {
    const res: any = await axios.get("/index/index/partner");
    if (res.code === 200) {
      setFirends(res.data.data);
    }
  };
  useEffect(() => {
    const initData = async () => {
      const res: any = await axios.get("/index/index/site");
      if (res.code === 200) {
        setCompanyInfo(res.data);
      }
      const imgRes: any = await axios.get("/index/images");
      if (imgRes.code === 200) {
        setCompanyImg(imgRes.data.data);
      }
      getFirend();
    };
    initData();
  }, []);
  const lang = sessionStorage.getItem("lang") || "ch";
  const TXT_INFO = lang === "en" ? en : ch;
  return (
    <div className="about">
      <Banner />
      <div className="li">
        <div className="title">{TXT_INFO.footer.aboutList[0]}</div>
        <div className="desc">
          <div dangerouslySetInnerHTML={{ __html: companyInfo.detail }} />
        </div>
      </div>
      <div className="li">
        <div className="title">{TXT_INFO.footer.aboutList[1]}</div>
        <div className="desc">
          <div dangerouslySetInnerHTML={{ __html: companyInfo.culture }} />
        </div>
      </div>
      <div className="li">
        <div className="title">{TXT_INFO.environment}</div>
        <div className="d-img-container">
          {companyImg.map((item: any) => {
            return <img className="d-img" src={item.url} alt={item.remark} />;
          })}
        </div>
      </div>
      <div className="li">
        <div className="title">{TXT_INFO.telMe}</div>
        <div className="desc">
          <div className="d-li">
            {TXT_INFO.headOffice}：{companyInfo.company_name}
          </div>
          <div className="d-li">
            {TXT_INFO.site}：{companyInfo.address}
          </div>
          <div className="d-li">
            {TXT_INFO.phone}：{companyInfo.phone}
          </div>
          <div className="d-li">
            {TXT_INFO.transmissionOfTruth}：{companyInfo.fax}
          </div>
          <div className="d-li">E-mail：{companyInfo.email}</div>
        </div>
      </div>
      <div className="li">
        {firends?.length ? (
          <div className="fc-firend">
            <div className="fc-f-title">{TXT_INFO.firend}</div>
            <div className="fc-f-ul">
              <InfinitePartnerScroll partners={firends} />
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default AboutPage;
